import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { usePartnerContext } from '../context'
import { query } from '../graphql'
import { getSpacesTableData } from '../helpers/spaces-table-data'

export const useTalentQuery = (talentId, username, options = {}) => {
  // Eigene Talent-Status des Partners für die Status-Ableitung. Alle Aufrufer
  // rendern unterhalb des PartnerContextProviders.
  const { partner } = usePartnerContext()

  return useQuery({
    queryKey: QUERY_KEYS.spaceById(talentId),
    queryFn: async () => {
      const space = await query({
        query: 'getSpace',
        variables: { id: talentId }
      })

      const cron_ttls = await query({
        query: 'listCronTTLBySourceID',
        variables: { source_id: space.id }
      })

      const logs = await query({
        query: 'logsBySpace',
        variables: { space_id: space.id }
      })

      return { ...space, cron_ttls, logs }
    },
    select: (space) => {
      if (space.soft_deleted) return null

      const result = getSpacesTableData({
        spaces: [space],
        user_id: username,
        customStatuses: partner.talentStatuses
      })

      return { ...result[0], original: space }
    },
    ...options
  })
}
